// import { GradienListAltIcon } from "../../../component/icons/icon-gradient";

import * as React from 'react';
import { CustomStatus } from "../../help/status";
import { GradienBorderColorIcon, GradienDeleteIcon } from "../../../component/icons/icon-gradient";

import { useContext } from "react";
import DataSourceContext from "../../../context/DataSourceMngContext";
import { Box, IconButton, Typography, Tooltip, Stack } from "@mui/material";
import {
  GradienCheckCircleIcon,
  GradienCancelIcon,
} from "../../../component/icons/icon-gradient";
import { CustomStackGrid, CustomStackRow, CustomAutocomplete, StyledPopper, StyledTextField } from "../../../styles/style";
import { GradienRemoveRedEyeIcon, GradienCalculateIcon } from "../../../component/icons/icon-gradient";



export const columns_onedrive = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "file_name",
      headerName: "File Name",
      headerAlign: "center",
      width: 250,
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <CustomStackRow direction="row">
            <CustomAutocomplete
              fullWidth
              multiple
              limitTags={1}
              defaultValue={params.row.file_name}
              options={params.row.file_name}
              getOptionLabel={(option) => option}
              disableClearable
              PopperComponent={StyledPopper}
              renderInput={(params) => <StyledTextField {...params}/>}
            />
          </CustomStackRow>
        );
      },
    },
    {
      field: "create_at",
      headerName: "Date",
      headerAlign: "center",
      width: 200,
      renderCell: (params) => {
        let content;
      
        if (params.row.activity_date) {
          const date = new Date(params.row.activity_date);
          const formatter = new Intl.DateTimeFormat("th-TH-u-ca-buddhist", {
            month: "long",
            year: "numeric",
          });
          content = formatter.format(date);
        } else if (params.row.create_at) {
          const date = new Date(params.row.create_at);
          content = `${date.toLocaleDateString("th-TH")} ${date.toLocaleTimeString("th-TH")}`;
        } else {
          content = "-";
        }
      
        return (
          <CustomStackRow direction="row" spacing={0.5} alignItems="center">
            <Typography sx={{ fontSize: "14px" }} align="start">
              {content}
            </Typography>
          </CustomStackRow>
        );
      },    
    },
    {
      field: "bill_type",
      sortable: false,
      flex: 1,
      width: 200,
      headerAlign: "center",
      align: "center",
      headerName: "Bills Type",
      renderCell: (params) => {
        const { transaction_types } = params.row;
        const bill_type = transaction_types?.map((item) => item).join(", ");
        return (
          <CustomStackRow direction="row" spacing={0.5} alignItems="center">
            <Typography sx={{ fontSize: "14px" }} align="center">
              {bill_type}
            </Typography>
          </CustomStackRow>
        );
      },
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
      width: 180,
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        const { file_name, total } = params.row;
        return (
          <CustomStackRow direction="row" spacing={0.5} alignItems="center">
            <Tooltip
              title={
                <Box>
                  <Typography sx={{ fontSize: "14px" }} align="start">
                    File(s)
                  </Typography>
                  <ul className="w-full mt-1 overflow-y-hidden">
                    {file_name.map((item, index) => (
                      <li key={`file-${index}`} className="w-full">
                        <Typography
                          sx={{ fontSize: "14px" }}
                          align="start"
                          noWrap
                        >
                          {index + 1}. {item}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                </Box>
              }
              enterDelay={500}
              leaveDelay={200}
            >
              <Typography
                sx={{ fontSize: "14px" }}
                align="center"
                className="cursor-pointer"
              >
                {total}
              </Typography>
            </Tooltip>
          </CustomStackRow>
        );
      },
    },
    {
      field: "total_success",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderHeader: () => (
        <Tooltip title={<Typography sx={{ fontSize: "14px" }} align="start">Successfully processed items</Typography>} arrow>
          <span>
            <GradienCheckCircleIcon sx={{ fontSize: 25 }} />
          </span>
        </Tooltip>
      ),    
      renderCell: (params) => {
        const { total_success } = params.row;
        return (
          <CustomStackRow direction="row" spacing={0.5} alignItems="center">
            <Typography sx={{ fontSize: "14px" }} align="center">
              {total_success}
            </Typography>
          </CustomStackRow>
        );
      },
    },
    {
      field: "total_failed",
      sortable: false,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Tooltip title={<Typography sx={{ fontSize: "14px" }} align="start">Needs review</Typography>} arrow>
          <span>
            <GradienCancelIcon sx={{ fontSize: 25 }} />
          </span>
        </Tooltip>
      ),    
      renderCell: (params) => {
        const { total_failed } = params.row;
        return (
          <CustomStackRow direction="row" spacing={0.5} alignItems="center">
            <Typography sx={{ fontSize: "14px" }} align="center">
              {total_failed}
            </Typography>
          </CustomStackRow>
        );
      },
    },
    {
      field: "in_progress",
      headerName: "Status",
      sortable: false,
      width: 180,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <CustomStackRow direction="row" spacing={0.5} alignItems="center">
            <Typography
              sx={{
                fontSize: "14px",
                color: params?.value ? "info.main" : "primary.main",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {params?.value ? "Processing" : "Done"}
            </Typography>
          </CustomStackRow>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 100,
      pinned: "right",
      renderCell: (params) => <ActionCell params={params} />,
    },
  ];

// const ActionCell = () => {
//     const { setDialog } = React.useContext(DataSourceContext);
//     return (
//         <CustomStackGrid direction="row" spacing={0.5}>
//             <GradienListAltIcon onClick={() => setDialog('device_details', true)} />
//             {/* <GradienDeleteIcon /> */}
//         </CustomStackGrid>
//     );
// };

const ActionCell = (props) => {
    const { params } = props;
    const { setDialog, fetchHistory } = useContext(DataSourceContext);
  
    const handleClick = () => {
      fetchHistory(params?.row?.id);
      setDialog("device_details", true);
    };
  
    return (
      <CustomStackGrid direction="row" spacing={0.5}>
        {params?.row?.in_progress ? null : (
          <>
            <IconButton onClick={handleClick}>
              <GradienRemoveRedEyeIcon fontSize={20} />
            </IconButton>
          </>
        )}
      </CustomStackGrid>
    );
  };